import styled from 'styled-components';

export const DialogElem = styled.dialog`
  ${({ theme }) => `
    width: fit-content;
    padding: 0;
    border: none;
    border-radius: 8px;

    &::backdrop {
      background: rgba(45, 45, 45, 0.7);  
    }

    @media ${theme.layout.breakpoints.max.tablet} {
      margin: auto ${theme.layout.spacing.centy};
    }   
  `};
`;
